// Venture Stream - JavaScript

// Breadcrumbs
(function () {
  var SESSION_KEY = 'dcbreadcrumb';

  var getSession = function () {
    try {
      return JSON.parse(sessionStorage.getItem(SESSION_KEY) || '{}');
    } catch (e) {
      return {};
    }
  };

  var saveSession = function (data) {
    try {
      sessionStorage.setItem(SESSION_KEY, JSON.stringify(data));
    } catch (e) { }
  };

  var findLinkByHref = function (root, href) {
    var links = root.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      if (links[i].getAttribute('href') === href) return links[i];
    }
    return null;
  };

  var BreadcrumbTrail = function () {
    return Reflect.construct(HTMLElement, [], BreadcrumbTrail);
  };

  BreadcrumbTrail.prototype = Object.create(HTMLElement.prototype);
  BreadcrumbTrail.prototype.constructor = BreadcrumbTrail;
  Object.setPrototypeOf(BreadcrumbTrail, HTMLElement);

  BreadcrumbTrail.prototype.connectedCallback = function () {
    var navEntry = window.performance && window.performance.getEntriesByType
      ? window.performance.getEntriesByType('navigation')[0]
      : null;
    this._navType = navEntry ? navEntry.type : null;

    this._trackVisit();
    var html = this._buildHtml();
    if (!html) {
      this.style.display = 'none';
      return;
    }
    this.innerHTML = html;

    if (this.dataset.debug) this._populateDebug();
  };

  // Finds the top-level nav item (e.g. "Womenswear") whose dropdown links to
  // collectionUrl, so the breadcrumb can show the shopper's real nav path
  // rather than just Home / Collection / Product.
  BreadcrumbTrail.prototype._megaMenuLookup = function (collectionUrl) {
    var nav = document.getElementById('SiteNav');
    if (!nav || !collectionUrl) return {};
    var link = findLinkByHref(nav, collectionUrl);
    if (!link) {
      this._lastMegaMenu = { matched: false };
      return {};
    }
    var topItem = link.closest('.nav-item');
    if (!topItem) {
      this._lastMegaMenu = { matched: false };
      return {};
    }
    var topLink = topItem.querySelector(':scope > .nav-link');
    if (!topLink || topLink === link) {
      this._lastMegaMenu = { matched: false };
      return {};
    }
    var result = { topLink: topLink.getAttribute('href'), topName: topLink.textContent.trim() };
    this._lastMegaMenu = { matched: true, topName: result.topName, topLink: result.topLink };
    return result;
  };

  // Remembers the collection a shopper is browsing (or clicked into a product
  // from) in sessionStorage, so the product breadcrumb reflects their actual
  // path instead of always falling back to the product's first collection.
  BreadcrumbTrail.prototype._trackVisit = function () {
    var url = window.location.pathname;
    var session = getSession();

    if (this.dataset.template === 'collection' && this.dataset.collectionUrl) {
      var collectionData = {
        url: this.dataset.collectionUrl,
        title: this.dataset.collectionTitle || '',
      };
      session.collection = collectionData;
      session.lastPageType = 'collection';
      saveSession(session);

      document.addEventListener(
        'click',
        function (event) {
          var mainContent = document.getElementById('MainContent');
          if (mainContent && mainContent.contains(event.target)) {
            var current = getSession();
            current.collection = collectionData;
            current.lastPageType = 'collection';
            saveSession(current);
          }
        },
        true
      );
    } else if (this.dataset.template === 'product') {
      var isRefresh = session.product && session.product.url === url;
      if (!isRefresh && session.lastPageType !== 'collection') {
        delete session.collection;
      }
      session.product = { url: url, title: this.dataset.productTitle || '' };
      session.lastPageType = 'product';
      saveSession(session);
    }
  };

  BreadcrumbTrail.prototype._buildHtml = function () {
    var session = getSession();
    var root = this.dataset.rootUrl || '/';
    var homeHtml = '<a href="' + root + '">Home</a>';

    if (this.dataset.template === 'collection') {
      var collectionUrl = this.dataset.collectionUrl;
      var collectionTitle = this.dataset.collectionTitle || '';
      if (!collectionUrl) return null;

      var topForCollection = this._megaMenuLookup(collectionUrl);
      var html = homeHtml;
      if (topForCollection.topLink && topForCollection.topName) {
        html +=
          ' <span aria-hidden="true">/</span> <a href="' +
          topForCollection.topLink +
          '">' +
          topForCollection.topName +
          '</a>';
      }
      html += ' <span aria-hidden="true">/</span> <span>' + collectionTitle + '</span>';
      return html;
    }

    if (this.dataset.template === 'product') {
      var productTitle = this.dataset.productTitle || '';
      var linkedCollection = session.collection
        ? session.collection
        : this.dataset.fallbackCollectionUrl
          ? { url: this.dataset.fallbackCollectionUrl, title: this.dataset.fallbackCollectionTitle || '' }
          : null;

      var html = homeHtml;

      if (linkedCollection && linkedCollection.url) {
        var top = this._megaMenuLookup(linkedCollection.url);
        if (top.topLink && top.topName) {
          html += ' <span aria-hidden="true">/</span> <a href="' + top.topLink + '">' + top.topName + '</a>';
        }
        html +=
          ' <span aria-hidden="true">/</span> <a href="' +
          linkedCollection.url +
          '">' +
          linkedCollection.title +
          '</a>';
      }

      if (productTitle) {
        html += ' <span aria-hidden="true">/</span> <span>' + productTitle + '</span>';
      }

      return html;
    }

    return null;
  };

  BreadcrumbTrail.prototype._populateDebug = function () {
    var session = getSession();

    var navEl = document.getElementById('breadcrumb-debug-navtype');
    if (navEl) navEl.textContent = this._navType || '—';

    var collectionEl = document.getElementById('breadcrumb-debug-collection');
    if (collectionEl) {
      collectionEl.textContent = session.collection ? session.collection.url : '—';
    }

    var megaMenuEl = document.getElementById('breadcrumb-debug-megamenu');
    if (megaMenuEl) {
      if (this._lastMegaMenu && this._lastMegaMenu.matched) {
        megaMenuEl.textContent = this._lastMegaMenu.topName + ' > ' + this._lastMegaMenu.topLink;
      } else {
        megaMenuEl.textContent = '— (no match in nav)';
      }
    }
  };

  if (!customElements.get('breadcrumb-trail')) {
    customElements.define('breadcrumb-trail', BreadcrumbTrail);
  }
})();

// End Breadcrumbs

// Product stock toggle
(function () {
  document.querySelectorAll('[data-product-stock-toggle]').forEach(function (button) {
    var section = button.closest('[data-section="product-main"]');
    if (!section) return;

    var variantsScript = section.querySelector('[data-product-variants]');
    var optionInputs = section.querySelectorAll('[data-product-option-index]');
    if (!variantsScript || !optionInputs.length) return;

    var variants = [];
    try {
      variants = JSON.parse(variantsScript.textContent || '[]');
    } catch (e) {
      variants = [];
    }

    var colorOnly = section.getAttribute('data-hide-out-of-stock-color-only') === 'true';
    var showSoldOut = false;

    var getSelectedOptionValues = function () {
      var values = [];
      optionInputs.forEach(function (input) {
        if (!input || input.type !== 'radio' || !input.checked) return;
        var index = parseInt(input.getAttribute('data-product-option-index'), 10);
        if (!Number.isFinite(index)) return;
        values[index] = input.value;
      });
      return values;
    };

    // Reveals any option currently hidden by theme.product.js when either the
    // shopper has toggled sold-out options on, or this section is scoped to
    // only hide colour options (non-colour options should always stay visible).
    var applyCorrections = function () {
      var selectedValues = getSelectedOptionValues();

      optionInputs.forEach(function (input) {
        if (!input || input.type !== 'radio') return;
        var isColorOption = input.getAttribute('data-option-is-color') === 'true';
        if (!showSoldOut && !(colorOnly && !isColorOption)) return;

        var index = parseInt(input.getAttribute('data-product-option-index'), 10);
        if (!Number.isFinite(index)) return;

        var value = input.value;
        var canMatch = variants.some(function (variant) {
          if (!variant || !variant.options || variant.options[index] !== value) return false;
          for (var i = 0; i < selectedValues.length; i += 1) {
            if (i === index) continue;
            if (!selectedValues[i]) continue;
            if (variant.options[i] !== selectedValues[i]) return false;
          }
          return true;
        });
        var hasAvailableMatch = variants.some(function (variant) {
          if (!variant || !variant.available || !variant.options || variant.options[index] !== value) return false;
          for (var i = 0; i < selectedValues.length; i += 1) {
            if (i === index) continue;
            if (!selectedValues[i]) continue;
            if (variant.options[i] !== selectedValues[i]) return false;
          }
          return true;
        });

        var label = input.nextElementSibling;
        input.hidden = false;
        input.disabled = !canMatch;
        if (label) {
          label.hidden = false;
          label.classList.toggle('is-unavailable', !canMatch);
          label.classList.toggle('is-sold-out', canMatch && !hasAvailableMatch);
        }
      });
    };

    var updateButton = function () {
      button.setAttribute('aria-pressed', showSoldOut ? 'true' : 'false');
      button.textContent = showSoldOut ? 'Hide sold out options' : 'Show sold out options';
    };

    var observerConfig = { attributes: true, attributeFilter: ['hidden', 'disabled', 'class'], subtree: true };
    // theme.product.js re-hides sold-out options whenever the shopper picks a
    // different option; watch for that and redo our corrections so the
    // toggle/colour-only scoping stays in effect instead of getting silently undone.
    var observer = new MutationObserver(function () {
      if (!showSoldOut && !colorOnly) return;
      observer.disconnect();
      applyCorrections();
      observer.observe(section, observerConfig);
    });

    if (colorOnly) applyCorrections();
    observer.observe(section, observerConfig);

    button.addEventListener('click', function () {
      showSoldOut = !showSoldOut;
      updateButton();

      if (showSoldOut) {
        applyCorrections();
        return;
      }

      var checkedInput = section.querySelector('[data-product-option-index]:checked');
      if (checkedInput) {
        checkedInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });
})();

// End Product stock toggle